import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  body: string
  confirmLabel: string
  onConfirm: () => void
  onCancel: () => void
}

/** A small anchored confirm (design: Delete popover); Esc or the backdrop cancels. */
export function ConfirmPopover({ title, body, confirmLabel, onConfirm, onCancel }: Props) {
  const { t } = useTranslation('library')
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onCancel()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCancel])
  return (
    <>
      <div className="lib-backdrop" onClick={onCancel} />
      <div className="lib-pop lib-confirm" role="dialog" aria-label={title}>
        <span className="lib-confirm-title">{title}</span>
        <span className="lib-confirm-body">{body}</span>
        <div className="lib-confirm-actions">
          <button type="button" className="lib-btn" onClick={onCancel}>
            {t('common.cancel')}
          </button>
          <button type="button" className="lib-btn lib-btn--primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </>
  )
}
